import { useEffect, useState } from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile(breakpoint = MOBILE_BREAKPOINT) {
	const [isMobile, setIsMobile] = useState<boolean | undefined>(undefined)

	useEffect(() => {
		const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`)
		const onChange = () => {
			setIsMobile(mql.matches)
		}
		mql.addEventListener("change", onChange)
		setIsMobile(mql.matches)
		return () => mql.removeEventListener("change", onChange)
	}, [breakpoint])

	return !!isMobile
}
